module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "semipolar-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.ringsStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "ring",
      style: (rs)
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40aee33e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/SemipolarSpinner.vue
// module id = 2161
// module chunks = 1